<template>
    <div>
        <div class="newheight"></div>

        <div class="jg-con">

            <div class="name">恭喜<label>{{author||'同学'}}</label></div>
            <div class="fen">{{result}}分</div>

        </div>
        <a href="javascript:void(0)" @click="$router.go(-2)" class="c-but"><img src="/img/jg-but.png"></a>
        <a href="javascript:void(0)" @click="$router.push({path: '/answer',query: {answerList, courseId}})" class="c-but look"><img src="/img/look.png"></a>
    </div>
</template>

<script>
    export default {
        name: "result",
        data(){
            return {
                result: this.$route.query.result,
                author: this.$route.query.author,//孩子姓名
                answerList: this.$route.query.answerList,//回答
                courseId: this.$route.query.courseId,//课程id
            }
        }
    }
</script>

<style scoped>
    .nav {height: 48px;padding-top: 20px;width: 100%;position: fixed;top: 0;text-align: center;display: flex;flex-direction: row;z-index: 9999;align-items: center;justify-content: center;font-size: 16px;line-height: 24px;margin: 0;padding: 0;font-weight: 600;}
    .newheight{ height:48px;}
    .jg-con{ width:210px; height:321px;  position:relative; margin:0 auto; margin-top:32px; background:url(/img/jg.png) center top no-repeat; background-size:210px;}
    .name{ width:126px; height:28px; position:absolute; top:147px; left:43px; font-size:15px; color:#FFF; font-weight:bold; line-height:28px; text-align:center;}
    .name label{ color:#ca0000; padding:0 5px;}
    .fen{ display:block; position:absolute; top:264px; width:100%; text-align:center; font-size:32px; color:#e71f19; font-weight:bold; }
    .c-but{ display:block; margin:0 auto; width:223px; height:48px; margin-top:50px;}
    .c-but img{ width:223px;}
    .look{margin-top: 10px;}
</style>
